// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3u2UP","Logo":"Toolbar_Logo__d0Ojv","DesktopOnly":"Toolbar_DesktopOnly__a7izb"};